const products = {
  "Textile Chemicals and Auxiliaries": {
    "Wetting Agents": [
      { name: "Bio Power Wet -MW", details: "Non Ionic Wetting Agent" },
      { name: "Bio Power Wet-WR", details: "Non Ionic Wetting & Re-wetting Agent" },
      { name: "Bio Power Wet-100", details: "Non Ionic Wetting Agent Concentrate" },
      { name: "Bio Power Wash", details: "Perfect Multi-Purpose Product (Wetting, ABS, Cleaning Agent)" },
    ],
    "NPEO APEO Free Wetting Agents": [
      { name: "Bio Power Wet NPF-80", details: "NPEO APEO Free Wetting Agent" },
      { name: "Bio Power Wet NPF-50", details: "NPEO APEO Free Wetting Agent" },
    ],
    "Soaping Agents": [
      { name: "Bio Power AS Conc", details: "Concentrated Soaping Agent" },
      { name: "Bio Power AS L", details: "Liquid Soaping Agent" },
      { name: "Bio Power OT Conc", details: "Concentrated OT Paste" },
    ],
    "Anti Back Stain Agents": [
      { name: "Bio Power ABS – Conc.", details: "Anti Back Stain Conc." },
      { name: "Bio Power ABS – Liq.", details: "Anti Back Stain Liq." },
      { name: "Bio Power ABS Flakes", details: "Anti Back Stain Flakes" },
    ],
    "Water Softeners": [
      { name: "Bio Power Soft SEQ 70", details: "Water Softener Conc." },
      { name: "Bio Power Soft SEQ", details: "Water Softener" },
    ],
    "Fixing Agents": [
      { name: "Bio Power Fix - NFD", details: "Non Formaldehyde Fixing" },
      { name: "Bio Power Fix-NFD Conc", details: "Non Formaldehyde Fixing Conc" },
      { name: "Bio Power Fix-NFD 100", details: "High Conc. Fixing" },
    ],
    "Lubricating Agents": [
      { name: "Bio Power Lube-100", details: "Lubricant Powder 1:200 (Dilution)" },
      { name: "Bio Power Lube-Liq", details: "Lubricant Liq" },
    ],
    "Cationic Softeners": [
      { name: "Bio Power Soft – CSP", details: "Cat-ionic Softener Paste" },
      { name: "Bio Power Soft – CSL", details: "Cat-Ionic Softener Liq" },
      { name: "Bio Power Soft – CWS", details: "Cold Water Soluble Cationic Flakes" },
      { name: "Bio Power soft – HWS", details: "Hot Water Soluble Cationic Flakes" },
    ],
    "Anti Ozone Softeners": [
      { name: "Bio Power soft AO", details: "Anti Ozone Softener Liq" },
      { name: "Bio Power Soft AO Plus", details: "Anti Ozone Softener Paste" },
    ],
    "Non Ionic Softeners": [
      { name: "Bio Power Soft - NSP", details: "Non Ionic Softener Paste" },
      { name: "Bio Power soft - NS", details: "Non Ionic Softener Liq" },
      { name: "Bio Power soft - NSF", details: "Non Ionic Softener Flakes Hot Water Soluble" },
    ],
    "Silicon Emulsions": [
      { name: "Bio Power Sil - BS", details: "Nano Specialty Silicon Emulsion" },
      { name: "Bio Power Sil - 50", details: "Nano Specialty Silicon Emulsion" },
      { name: "Bio Power Sil - 70", details: "Nano Specialty Silicon Emulsion Concentrate" },
      { name: "Bio power Sil - HP", details: "Hydrophilic Specialty Silicon Emulsion" },
      { name: "Bio power Sil - HHS", details: "Nano Specialty Silicon Emulsion" },
      { name: "Bio power Sil - FHS", details: "Hydrophilic Specialty Silicon Emulsion" },
      { name: "Bio power Ultra Conc - SP", details: "Multi Specialty Silicon Softener Conc" },
    ],
    "Amylace Enzymes": [
      { name: "Bio Power Zyme -DL", details: "De-sizing Enzyme" },
      { name: "Bio Power zyme-DL 10", details: "De-sizing Enzyme 1:9" },
      { name: "Bio Power zyme-DL 50", details: "De-sizing Enzyme 1:50" },
      { name: "Bio Power Zyme-DL 100", details: "De-sizing Enzyme 1:100" },
    ],
    "Acid Bio Polish Enzymes [Acid Cellulase]": [
      { name: "Bio Power Zyme -CP", details: "Biopolishing Enzyme" },
      { name: "Bio Power Zyme -CP Conc", details: "Biopolishing Enzyme Concentrate" },
      { name: "Bio Power zyme-AB", details: "Biopolishing Enzyme" },
      { name: "Bio Power zyme-AB Conc", details: "Biopolishing Enzyme Concentrate" },
      { name: "Bio Power Zyme-AC Conc", details: "Bio Polishing Enzyme Concentrate" },
      { name: "Bio Power Zyme -AB 100", details: "Acid Bio Polish Enzyme Concentrate" },
    ],
    "Neutral Bio Polish Enzymes [Neutral Cellulase]": [
      { name: "Bio Power Zyme NB", details: "Neutral Bio Polishing Enzyme Liq" },
      { name: "Bio Power zyme NB - 100", details: "Neutral Bio Polishing Enzyme Concentrate Liq" },
      { name: "Bio Power zyme NC", details: "Neutral Bio Polishing Enzyme Liq" },
      { name: "Bio Power zyme NC Conc", details: "Neutral Bio Polishing Enzyme Concentrate Liq" },
    ],
    "Neutral Fading Enzymes [Neutral Cellulase]": [
      { name: "Bio Power Zyme - LTCF", details: "Neutral Fading / Cutting Liq Enzyme" },
      { name: "Bio Power Zyme – LTCF Plus", details: "Neutral Fading / Cutting Liq Enzyme Conc" },
      { name: "Bio Power Zyme NG - 100", details: "Neutral Enzyme Granules Concentrate (Powder)" },
      { name: "Bio Power zyme NG Plus", details: "Neutral Enzyme Granules (Powder)" },
      { name: "Bio Power Zyme NG", details: "Neutral Enzyme Granules (Powder)" },
    ],
    "Speciality Products": [
      { name: "Bio Power Bright - SB", details: "Optical Brightener Powder" },
      { name: "Bio Power Bloom-S", details: "Blooming Agent" },
      { name: "Bio Power Stiff - PVH", details: "Stiffening Agent" },
    ],
  },

  "Laundry and Home Care Products": {
    "Laundary": [
      { name: "Bio Power Perfect Wash Conc", details: "Detergent Liquid Concentrate" },
      { name: "Bio Power Perfect Wash - L", details: "Detergent Liquid" },
      { name: "Bio Power Perfect Soap Conc", details: "Soap Concentrate" },
      { name: "Bio Power Perfect Soap - L", details: "Soap Liquid" },
      { name: "Bio Power Perfect Soft", details: "Fabric Softener" },
    ],
    "Home Care": [
      { name: "Bio Power Perfect Shine", details: "Dish Washing Liquid" },
      { name: "Bio Power Perfect Hands", details: "Hand Wash Liquid" },
      { name: "Bio Power Perfect Clean - FC ", details: "Floor Cleaner" },
      { name: "Bio Power Perfect Clean - TC ", details: "Toilet Cleaner" },
      { name: "Bio Power Perfect SAN IPG - 100 ", details: "Multi-Purpose Sanitizer" },
      { name: "Bio Power Perfect SAN IPG - 70 ", details: "Multi-Purpose Sanitizer" },
    ],
  },
};

export default products;
